import React from 'react'

export default function PageNotFound() {
    return (
        <>
            <h1>404 ! Page not found</h1>
        </>
    )
}
